// UID: NPO-BYLAW-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2246
import loanFormModel from '../../form_models/loanFormModel';

import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import NonProfitBylawsCopyRuleset from '../../business/ruleset/NonProfitBylawsCopyRuleset';
import { RulesetResult } from '../../business/rules/';

const { nonProfitBylawsCopy } = loanFormModel.formField.companyDocuments;

export class NonProfitBylawsCopyValidation implements ValidationSchema {
  public name = nonProfitBylawsCopy.name;
  public label = nonProfitBylawsCopy.label;
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public ruleset = NonProfitBylawsCopyRuleset;

  public when(schema: any, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    schema = FileNameValidationSchema(nonProfitBylawsCopy.name, required);
    if (required) schema = schema.required('This document is required');
    return schema;
  }
}
export default new Validation(new NonProfitBylawsCopyValidation());
